import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService, TRACK_ACTION } from '../services/analytics.service';
import { FieldsDataService } from '../services/fields-data.service';
import {
  FilterItem,
  Filters,
  FiltersService,
  PriceFilter,
} from '../services/filters.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit {
  filters: Filters;

  get visibleFieldsCount$() {
    return this.fieldsDataService.getVisibleFieldsCount();
  }
  constructor(
    private modalController: ModalController,
    private filtersService: FiltersService,
    private fieldsDataService: FieldsDataService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.filtersService.getFilter().subscribe((filters) => {
      console.log('filters: ', filters);
      this.filters = filters;
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  setFilter(filter: FilterItem | PriceFilter) {
    this.filtersService.setFilter(filter);

    this.analyticsService
      .trackAction(TRACK_ACTION.SET_FILTER, filter.name)
      .subscribe((res) => console.log(res));
  }

  savePriceRange(event: any) {
    this.setFilter({
      name: 'Цена',
      value: {
        lower: event.detail.value.lower,
        upper: event.detail.value.upper,
      },
    });

    this.analyticsService
      .trackAction(TRACK_ACTION.SET_FILTER, 'Цена')
      .subscribe((res) => console.log(res));
  }

  resetFilters() {
    this.filtersService.resetFilters();
  }
}
